import React from 'react';
import DashboardV2MiniCard from './DashboardV2MiniCard';
import DashboardV2VendeurLabel from './DashboardV2VendeurLabel';
import { formatDashboardNumber, formatDashboardCa, getRowLineClass } from '../../../utils/dashboardV2Utils';

const DashboardV2SigneRows = ({ rows = [], colorByName = {} }) => {
  if (!rows.length) {
    return <div className="p-3 text-muted">Aucune donnée disponible.</div>;
  }

  return rows.map((row, idx) => (
    <div key={`${row.vendeur}-${idx}`} className={`v2-row-line ${getRowLineClass(row)}`}>
      <DashboardV2VendeurLabel vendeur={row.vendeur} rowType={row._row_type} colorByName={colorByName} />
      <div className="v2-cards-grid cols-6">
        <div className="v2-pair">
          <DashboardV2MiniCard label="Nouveaux NB" value={formatDashboardNumber(row.nouveaux_nb)} bgClass="v2-bg-nouveau" />
          <DashboardV2MiniCard label="Nouveaux CA" value={formatDashboardCa(row.nouveaux_ca)} bgClass="v2-bg-nouveau" />
        </div>
        <div className="v2-pair">
          <DashboardV2MiniCard label="Fidélisés NB" value={formatDashboardNumber(row.fidelises_nb)} bgClass="v2-bg-fidelisee" />
          <DashboardV2MiniCard label="Fidélisés CA" value={formatDashboardCa(row.fidelises_ca)} bgClass="v2-bg-fidelisee" />
        </div>
        <div className="v2-pair" style={{ gridColumn: 'span 2' }}>
          <DashboardV2MiniCard label="Total NB" value={formatDashboardNumber(row.total_nb)} bgClass="v2-bg-total" />
          <DashboardV2MiniCard label="Total CA" value={formatDashboardCa(row.total_ca)} bgClass="v2-bg-total" />
        </div>
      </div>
    </div>
  ));
};

export default DashboardV2SigneRows;
